var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.1 14.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.7;\n      }\n\n      .cls-2 {\n        fill: #403f4c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_camera",
    className: "cls-1",
    transform: "translate(-6.9 -13.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9211",
    "data-name": "Path 9211",
    className: "cls-2",
    d: "M24,18.2A2.22,2.22,0,0,0,21.8,16H19.6l-.2-.8a2.14,2.14,0,0,0-2.1-1.7H13.5a2.14,2.14,0,0,0-2.1,1.7l-.2.8H9.1a2.22,2.22,0,0,0-2.2,2.2v7.7a2.22,2.22,0,0,0,2.2,2.2H21.8A2.22,2.22,0,0,0,24,25.9Zm-1.3,0v7.7a.9.9,0,0,1-.9.9H9.1a.9.9,0,0,1-.9-.9V18.2a.9.9,0,0,1,.9-.9h2.6a.634.634,0,0,0,.6-.5l.3-1.3a.961.961,0,0,1,.9-.7h3.8a.961.961,0,0,1,.9.7l.3,1.3a.634.634,0,0,0,.6.5h2.6A.923.923,0,0,1,22.7,18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9212",
    "data-name": "Path 9212",
    className: "cls-2",
    d: "M15.4,17.3a4.3,4.3,0,1,0,4.3,4.3A4.207,4.207,0,0,0,15.4,17.3Zm3.1,4.3a3,3,0,1,1-3-3A3.009,3.009,0,0,1,18.5,21.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCamera);
export default __webpack_public_path__ + "static/media/ico_camera.89ee951a7d6978c436aaf3db941edfd7.svg";
export { ForwardRef as ReactComponent };